import * as React from "react";

import { createHocDisplayName, GetProps } from "./TypingUtils";

const RedefinedViewModelIndexContext = React.createContext<number | undefined>(undefined);

export function useRedefinedViewModelIndex(): number | undefined {
    return React.useContext(RedefinedViewModelIndexContext);
}

interface RedefineViewModelIndexProps {
    redefinedViewModelIndex: number;
    children: React.ReactNode;
}

export function RedefineViewModelIndex(props: RedefineViewModelIndexProps): JSX.Element {
    return (
        <RedefinedViewModelIndexContext.Provider value={props.redefinedViewModelIndex}>
            {props.children}
        </RedefinedViewModelIndexContext.Provider>
    );
}

interface RedefinedViewModelIndexInjectableProps {
    redefinedViewModelIndex: undefined | number;
}

export function withRedefinedViewModelIndex<
    C extends React.ComponentType<GetProps<C> & RedefinedViewModelIndexInjectableProps>,
>(
    WrappedComponent: C
): React.ComponentType<Omit<JSX.LibraryManagedAttributes<C, GetProps<C>>, "redefinedViewModelIndex">> {
    function WithRedefinedViewModelIndexWrapper(
        props: Omit<JSX.LibraryManagedAttributes<C, GetProps<C>>, "redefinedViewModelIndex">
    ): JSX.Element {
        const redefinedViewModelIndex = useRedefinedViewModelIndex();
        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        return <WrappedComponent {...props} redefinedViewModelIndex={redefinedViewModelIndex} />;
    }

    WithRedefinedViewModelIndexWrapper.displayName = createHocDisplayName(WrappedComponent, "RedefinedViewModelIndex");
    return WithRedefinedViewModelIndexWrapper;
}
